<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "App",
  data() {
    return {
      msg: 10,
      vwPath: false,
    };
  },
  methods: {
    /* 
    http://uservue2.jinfu.baohan.com/customer/seal/jiangXiSealCommit?taction=GongcTenderbidInsure&token=f47fef44401eeaf23f75302169ef6caa7b7547c45fe3f3efc71148270bac79ef&tradeNo=20220922145533bbVwLsRhAJKGPV&tv=v1
    */
    bodyScale() {
      var devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度
      var scale = devicewidth / 1920; // 分母——设计稿的尺寸
      // @ts-ignore
      document.body.style.zoom = scale; //放大缩小相应倍数
    },
  }
};
</script>
<style lang="less">
// // @import '~@/assets/css/var.less';
.vhtml {
  // overflow-y: scroll;
  -ms-overflow-style: none;
  /* IE 和 Edge */
  scrollbar-width: none;

  /* Firefox */
  .set-img {
    img {
      max-width: 100% !important;
    }

  }

}

#app-wrap,
#app {
  min-height: 100vh;
  background: #f7f7f9;
  min-width: 1024px;
  /* width: 100vw; */
}

/* 修改个别 el-input 高度 */
.large_input input {
  height: 48px;
  // box-shadow: inset 0 2px 1px 0 hsla(0, 0%, 93.3%, .9333333333333333) !important;
}

.large_input .el-input__inner {
  border-radius: 4px;
}

.large_input .el-input__icon {
  line-height: 48px;
}

.large_input .el-input__prefix {
  left: 14px;
}

.large_input.el-input--prefix .el-input__inner {
  padding-left: 46px !important;
}

img {
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}

.el-tooltip__popper {
  max-width: 500px;
}
</style>
